import apolloClient from "@src/utilities/apollo-client"

import { CART_UPDATE_FREQUENCY } from "@src/operations/api/cart"

import type {
  UpdateFrequencyInCartMutation,
  UpdateFrequencyInCartMutationVariables,
} from "@src/entities/types/api"

export default async function updateFrequencyInCart(
  input: UpdateFrequencyInCartMutationVariables["input"]
) {
  return apolloClient.mutate<
    UpdateFrequencyInCartMutation,
    UpdateFrequencyInCartMutationVariables
  >({
    mutation: CART_UPDATE_FREQUENCY,
    variables: { input },
  })
}
